module.exports = __webpack_public_path__ + "static/img/bg-privatnost.4e4753f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/privatnost/bg-privatnost.jpg
// module id = Dkhk
// module chunks = 1